import { HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** SILQ HTTP hosts. Anything else (i18n, assets, geo/IP, HubSpot, blobs) must keep working without a session. */
function silqBackendBases(): string[] {
  return [
    environment.APIEndpointDeliverable,
    environment.APIEndpoint,
    environment.ReportAPIEndpoint,
    environment.ReportUrl,
    environment.DocumentsAPIEndpoint,
    environment.DocumentsUrl,
    environment.DatabaseAPIEndpoint,
  ].filter((base): base is string => !!base);
}

export function isSilqBackendUrl(url: string): boolean {
  if (!url) {
    return false;
  }
  return silqBackendBases().some((base) => url.startsWith(base));
}

function pathnameOf(url: string): string {
  try {
    return new URL(url, 'http://local').pathname.replace(/\/+$/, '') || '/';
  } catch {
    return url;
  }
}

/** Login, password reset, 2FA, SSO start, trial/signup — these run with no session. */
export function isPublicSilqBackendUrl(url: string): boolean {
  const path = pathnameOf(url);
  return (
    path.endsWith('/login') ||
    path.endsWith('/oauth-connections') ||
    path.endsWith('/SetDatabase') ||
    path.endsWith('/OAuth2Start')
  );
}

export function isPublicUnauthenticatedRequest(request: HttpRequest<any>): boolean {
  if (request.headers?.get('skip')) {
    return true;
  }
  const url = request.url || '';
  if (!isSilqBackendUrl(url)) {
    return true;
  }
  return isPublicSilqBackendUrl(url);
}

export function shouldCancelHttpWithoutSession(
  request: HttpRequest<any>,
  isLoggingOut: boolean,
): boolean {
  if (!isLoggingOut && localStorage.getItem('session_token')) {
    return false;
  }
  return !isPublicUnauthenticatedRequest(request);
}

export function isSessionGoneApiBody(body: any): boolean {
  if (!body || typeof body !== 'object' || Array.isArray(body) || body instanceof Blob) {
    return false;
  }
  return (
    body.CODE == 436 ||
    body.CODE == '436' ||
    body.MESSAGE == 'No Session Token' ||
    body.MESSAGE == 'Not logged in'
  );
}
